import { Alert, Card, CardContent, CardHeader, Typography } from "@mui/material";
import DownloadPDFButtons from "../general/DownloadPDFButtons";
import { RememberMe, StickyNote2 } from "@mui/icons-material";
import PDFKartuPeserta from "../PDF/PDFKartuPeserta";
import { useRef, useState } from "react";
import PDFUndangan from "../PDF/PDFUndangan";
import { STATUS_PROGRESS } from "../../helper/Constant";
import PDFCommon from "../PDF/PDFCommon";

function DetailUndangan({ data_santri, dataBerkas }) {
    const kartuPesertaRef = useRef();
    const suratUndangaRef = useRef();

    // ✅ Track loading state for each PDF
    const [pdfLoadingStates, setPdfLoadingStates] = useState({
        kartuPeserta: true,
        suratUndangan: true
    });

    // ✅ Check if all PDFs are loaded
    const allPdfsLoaded = !Object.values(pdfLoadingStates).some(state => state === true);

    // ✅ Callback when PDF is loaded
    const handlePdfLoaded = (pdfName, success) => {
        console.log(`📄 ${pdfName} loaded:`, success);
        setPdfLoadingStates(prev => ({
            ...prev,
            [pdfName]: false
        }));
    };


    const GenerateContent = () => {
        if (data_santri.status === STATUS_PROGRESS.UNDANGAN_UJIAN) {
            const buttonsConfig = [
                {
                    label: 'Kartu Peserta Ujian',
                    icon: RememberMe,
                    ref: kartuPesertaRef,
                    pdfComponent: PDFCommon,
                    fileName: `kartu-peserta-${data_santri.no_daftar}.pdf`,
                    data: {
                        dataSantri: data_santri,
                        templateKey: 'kartu_peserta',
                        onLoadComplete: (success) => handlePdfLoaded('kartuPeserta', success) // ✅ Add callback
                    },
                    orientation: 'landscape'
                },
                {
                    label: 'Surat Undangan',
                    icon: StickyNote2,
                    ref: suratUndangaRef,
                    pdfComponent: PDFCommon,
                    fileName: `surat-undangan-${data_santri.no_daftar}.pdf`,
                    data: {
                        dataSantri: data_santri,
                        templateKey: 'undangan',
                        onLoadComplete: (success) => handlePdfLoaded('suratUndangan', success) // ✅ Add callback
                    },
                }
            ];

            return (
                <>
                    Download berkas-berkas berikut untuk dicetak dan dibawa saat pelaksanaan Test/Ujian.
                    {/* ✅ Show loading message */}
                    {!allPdfsLoaded && (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, mt: 1 }}>
                            ⏳ Memuat data PDF... Mohon tunggu sebentar.
                        </Typography>
                    )}

                    {/* ✅ Pass loading state to buttons */}
                    <DownloadPDFButtons
                        buttons={buttonsConfig}
                        disabled={!allPdfsLoaded} // ✅ Disable until loaded
                    />
                </>
            )
        }
        return (
            <>
                <Alert title="Undagan Belum dapat dilihat" variant="filled" severity="warning" sx={{ marginBottom: "15px" }}>
                    Undangan baru dapat dilihat jika semua berkas sudah lengkap, sudah membayar biaya pendaftaran, dan sudah dijadwalkan oleh panitia.
                    Jika sudah lengkap, undangan insya Allah dapat didownload pada bagian ini setelah 3-7 hari.
                </Alert>
            </>
        )
    };

    return (
        <>
            <Card>
                <CardHeader title="Undangan Seleksi" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    {GenerateContent()}
                </CardContent>
            </Card>

        </>
    )
}

export default DetailUndangan;